<template>
  <div class="form_">
    <cube-form
      :model="form"
      @validate="validateHandler"
      @submit="submitHandler"
    >
      <div class="title_">
        登录信息
      </div>
      <cube-form-group style="padding: 0 5px;">
        <cube-form-item :field="field[0]">
          <cube-input
            v-model="form.adminUsername"
            @blur="handleBlur1"
            @input="handleChange"
            :eye="eye"
            :clearable="clearable"
            :placeholder="placeholder"
          ></cube-input>
        </cube-form-item>
        <cube-form-item :field="field[1]" v-if="personal">
          <div class="ver_f_">
            <cube-input
              v-model="form.verificationCode"
              :eye="eye"
              :clearable="clearable"
              @input="handleChange"
              placeholder="请输入短信验证码"
            ></cube-input>
            <span @click="getVeriCode" class="verCode_">{{ veriTxt }}</span>
          </div>
        </cube-form-item>
        <cube-form-item :field="field[2]">
          <cube-input
            v-model="form.adminPassword"
            type="password"
            :eye="eye"
            @blur="handleBlur2"
            @input="handleChange"
            :clearable="clearable"
            placeholder="至少8位,必须包含字母和数字"
          ></cube-input>
        </cube-form-item>
      </cube-form-group>

      <cube-button
        type="submit"
        :class="[disabled ? 'gray_' : '']"
        :disabled="disabled"
        class="btn_"
        @click="register"
        >注册</cube-button
      >
      <div style="display: flex;align-items: center;justify-content: center;">
        <input type="checkbox" v-model="checked">
        注册表示您已同意
        <a class="color_" target="_blank" href="http://nsale.ssish.com/m/nsale/pdfView">《用户注册协议》</a>
      </div>
    </cube-form>
  </div>
</template>

<script>
import options from "./options";
import common from "./common.js";
import api from "@/utils/api";
const required = {
  rules: {
    required: true
  }
};
const field = [
  {
    modelKey: "adminUsername",
    label: "用户名",
    ...required
  },
  {
    modelKey: "verificationCode",
    label: "验证码",
    ...required
  },
  {
    modelKey: "adminPassword",
    label: "登录密码",
    ...required
  }
];

export default {
  data() {
    document.title = '注册'
    return {
      checked:false,
      eye: {
        open: false,
        reverse: false
      },
      veriTxt: "获取验证码",
      veriTime: 60,
      // disabled: true,
      disabled: false,
      clearable: {
        visible: true,
        blurHidden: false
      },
      placeholder: "请输入登录用户名",
      field,
      personal: false,
      query: {},
      formInfo:{},
      uploadInfo:"",
      form: {
        adminUsername: "",
        verificationCode: "",
        adminPassword: ""
      },
      stInter:null
    };
  },
  mounted() {
    this.query = this.$route.query;
    if (this.query.cporpa == "2") {
      this.placeholder = "请输入登录手机号";
      this.personal = true;
    }
    this.formInfo = this.getSession("f_")
    this.uploadInfo = this.getSession("u_")
  },
  methods: {
    ...common,
    handleBlur1(){
      let phoneR = /(^(0)?(13[0-9]|14[5|7|8|9]|15[0-9]|166|18[0-9]|17[0|1|3|5|6|7|8]|19[8|9])[0-9]{8}$)|(^(00852|00886|00853)[0-9]{1,15}$)/;
      if(this.personal){
        if(!phoneR.test(this.form.adminUsername)){
          this.showToast("请输入正确手机号");
          this.form.adminUsername = ""
        }
      }
    },
    handleChange(e){
      if(this.query.cporpa == "1"){
        this.checkAllInfo()
      } else {
        this.checkAllInfo2()
      }
    },
    checkAllInfo(){
      let form = this.form
      // if(form.adminUsername&&form.adminPassword){
      //   this.disabled = false
      // } else {
      //   this.disabled = true
      // }
    },
    checkAllInfo2(){
      let form = this.form
      // if(form.adminUsername&&form.adminPassword&&form.verificationCode){
      //   this.disabled = false
      // } else {
      //   this.disabled = true
      // }
    },
    handleBlur2(){
      console.log(1)
      let passworsRex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,100}$/
      if(!passworsRex.test(this.form.adminPassword)){
          this.showToast("至少8位，必须包含字母和数字");
          this.form.adminPassword = ""
        }
    },
    getVeriCode() {
      if (!this.form.adminUsername) {
        this.showToast("请输入登录手机号");
        return;
      }
      if (this.veriTime == 60) {
        this.sendMessage();
      }
    },
    handleInput() {
      this.checkVerificationCode();
    },
    setTime() {
      if (60 == this.veriTime) {
        this.stInter = setInterval(() => {
          this.veriTxt = this.veriTime + "s";
          this.veriTime--;
          if (0 == this.veriTime) {
            this.veriTxt = "获取验证码";
            this.veriTime = 60
            clearInterval(this.stInter);
          }
          console.log(this.veriTime)
        }, 1000);
      }
    },
    register(){
      if(!this.checked){
        this.showToast('请阅读用户注册协议并勾选')
        return
      }
      let data = {
        param: this.formInfo.param,
        channelType: this.formInfo.channelType,
        cporpa: this.formInfo.cporpa,
        channelName: this.formInfo.channelName,
        adminName: this.formInfo.adminName,
        adminPhone: this.formInfo.adminPhone,
        adminUsername: this.form.adminUsername,
        adminPassword: this.form.adminPassword
      }
      if(this.query.cporpa == '1'){
        data.cplicenseurl = this.uploadInfo
      } else{
        data.verificationCode = this.form.verificationCode
      }
      api.register(data).then(res=>{
        this.setSession('l_', this.form)
        this.$router.push({name:'inviteSuccess'})
      }).catch(()=>{
        this.form.verificationCode = ''
        this.veriTxt = "获取验证码";
        this.veriTime = 60
        clearInterval(this.stInter);
      })
    },
    sendMessage() {
      //取验证码
      let data = {
        phones: this.form.adminUsername
      };
      api.sendMessage(data).then(res => {
        // 短信服务宕机下临时处理
        let data = res.data;
        const dataAll = Object.assign(data.content || {},data.data || {});
        if(dataAll && dataAll.defaultFlag && dataAll.defaultFlag == 'Y') {
          this.form.verificationCode = dataAll.verificationCode
        }else{
          this.$toast('验证码已发送');
        }
        this.setTime();
      });
    },
    checkVerificationCode() {
      //y验证验证码
      let data = {
        phones: this.form.adminUsername,
        verificationCode: this.form.verificationCode
      };
      api
        .checkVerificationCode(data)
        .then(res => {
          this.disabled = false;
        })
        .catch(err => {
          // this.disabled = true;
        });
    },
    submitHandler(e) {
      e.preventDefault();
      let form = this.form; //form数据
      console.log(form, "form");
    },
    validateHandler(result) {
      this.validity = result.validity;
      this.valid = result.valid;
      console.log(
        "validity",
        result.validity,
        result.valid,
        result.dirty,
        result.firstInvalidFieldIndex
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.form_ {
  font-family: PingFangSC-Regular, PingFang SC;
  background: #fafafa;
  width: 100%;
  .title_ {
    font-size: 0.48rem;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    position: relative;
    text-align: left;
    padding: 0.33rem 0;
    padding-left: 20px;
    background: #f8f8f8;
    &::after {
      content: "";
      position: absolute;
      top: 33%;
      left: 0px;
      width: 0.07rem;
      height: 0.43rem;
      background: rgba(27, 124, 248, 1);
    }
  }
  .select_1 {
    text-align: left;
    color: rgba(51, 51, 51, 1);
  }
  .select_ {
    text-align: left;
    color: rgba(51, 51, 51, 1);
    // position: relative;
    .down_ {
      position: relative;
      height: 0.506667rem;
      width: 0.506667rem;
      display: inline-block;
      &::after {
        content: "";
        position: absolute;
        top: 0.3rem;
        right: 0.346667rem;
        width: 0;
        height: 0;
        border: 3px solid transparent;
        border-top-color: black;
      }
    }
  }
  .ver_f_ {
    display: flex;
    .verCode_ {
      width: 90px;
      font-size: 14px;
      color: rgba(27, 124, 248, 1);
      display: flex;
      align-items: center;
    }
  }

  .color_{
    color: rgba(27, 124, 248, 1);
  }
  .gray_ {
    background: #aaa !important;
    color: #fff !important;
  }
  .btn_ {
    background: rgba(27, 124, 248, 1);
    font-size: 16px;
    font-weight: bold;
    border-radius: 6px;
    margin: 20px auto;
    color: #fff;
    width: 90% !important;
  }
}
</style>
